import {
  Container,
  ContentLayout,
} from "@cloudscape-design/components";
import { Mode } from "@cloudscape-design/global-styles";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import { useNavigate, useLocation } from "react-router-dom";
import { navigateFn } from "../../../routingHelper";
import SeriesNav from "../../../components/series-navbar/series-nav";
import GetSeriesContent from "../get-series-content";
import Rules from "./rules";
import Gallery from "./gallery";
import Register from './register';
import Results from "./results";
import Calendar from "./calendar";
import DriversAndTeams from "./teams";
import Stats from "./stats";


export default function Series() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();
  const { 
    theme, setTheme, 
    density, setDensity,
    seriesContent, setSeriesContent,
  } = useContext(GlobalContext);


  return (
    <>
      <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", width: "100%", height: "100%"}}>
        <img
          src="/images/f4a/f4a-1.jpg"
          alt="F4A Series"
          width={"100%"}
        />
        <img
          src="/images/f4a/f4a-2.jpg"
          alt="F4A Series"
          width={"100%"}
        />
        <img
          src="/images/f4a/f4a-3.jpg"
          alt="F4A Series"
          width={"100%"}
        />
        <img
          src="/images/f4a/f4a-4.jpg"
          alt="F4A Series"
          width={"100%"}
        />
        <img
          src="/images/f4a/f4a-6.jpg"
          alt="F4A Series"
          width={"100%"}
        />
        <img
          src="/images/f4a/f4a-7.jpg"
          alt="F4A Series"
          width={"100%"}
        />
        <img
          src="/images/f4a/f4a-8.jpg"
          alt="F4A Series"
          width={"100%"}
        />
      </div>
    </>
  );
}
